import { Icon } from "@fluentui/react";
import React from "react";
import { connect } from "react-redux";
import { localize } from "src/l10n";
import { Label } from "src/ui";
import UnstyledButton from "../Buttons/UnstyledButton/UnstyledButton";
import "./SpintrPagination.scss";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";

interface IProps {
    activePage: number;
    totalCount: number;
    pageSize?: number;
    onPageChange: (index: number) => void;
    smallViewMode: boolean;
}

interface ISpintrPaginationPart {
    type: "number" | "dots";
    number?: number;
}

const SpintrPagination = React.memo((props: IProps) => {
    const defaultPageSize = 10;
    const pageSize = props.pageSize ? props.pageSize : defaultPageSize;
    const pageCount = Math.ceil(props.totalCount / pageSize);
    const numberOfPageButton = props.smallViewMode ? 3 : 5;

    const getParts = () => {
        let result = [
            0,
            1,
            2,
            props.activePage -1,
            props.activePage,
            props.activePage + 1,
            pageCount - 3,
            pageCount - 2,
            pageCount - 1
        ];

        result = result.filter((value, index, array) => {
            return value > -1 &&
                value < pageCount &&
                array.indexOf(value) === index;
        }).sort((a, b) => a - b);

        const insertDotsAfterNumbers = [];

        for (let i = 0; i < result.length; i++) {
            if (i !== (result.length - 1) &&
                (result[i + 1] - result[i] !== 1)) {
                insertDotsAfterNumbers.push(result[i]);
            }
        }

        let items : ISpintrPaginationPart[] = result.map((number: any) => {
            return {
                type: "number",
                number
            }
        })

        for (let number of insertDotsAfterNumbers) {
            const index = items.findIndex(x => x.number === number) + 1;

            items.splice(index, 0, {
                type: "dots"
            });
        }

        if (items.length === 11) {
            items.splice(1, 1);
            items.splice(1, 1);
            items.splice(items.length - 2, 1);
            items.splice(items.length - 2, 1);
        }

        return items;
    }

    const parts = getParts();

    if (parts.length < 2) {
        return null;
    }

    return (
        <div className="SpintrPagination">
            <div className="SpintrPagination-inner">
                {
                    parts.map((p: ISpintrPaginationPart, index: number) => {
                        if (p.type === "dots") {
                            return <Visage2Icon icon={"more-circle"} color="mid-grey" key={index} />
                        }

                        return (
                            <UnstyledButton
                                ariaLabel={localize("Sida2") + " " + (p.number + 1)}
                                key={index}
                                className={p.number === props.activePage ? "active primaryBGColor number" : "number"}
                                onClick={() => {
                                    props.onPageChange(p.number);
                                }}>
                                <Label
                                    color={p.number === props.activePage ? "white" : "mid-grey"}
                                    size="body-2"
                                    weight={p.number === props.activePage ? "bold" : "normal"}>
                                    {
                                        p.number + 1
                                    }
                                </Label>
                            </UnstyledButton>
                        )
                    })
                }
            </div>
        </div>
    )
});

const mapStateToProps = (state: Spintr.AppState, props) => ({
    ...props,
    smallViewMode: state.ui.isSmallViewMode,
});

export default connect(mapStateToProps)(SpintrPagination);
